export default __webpack_public_path__ + "static/media/fb_profile_icon.a87389c6.svg";